import en from "./en";
import es from "./es";
import pt from "./pt";
var locales = {
  es: es,
  pt: pt,
  en: en
};
export default locales;